import { Colors } from "@blueprintjs/core";
import styled from "styled-components";
const TitleComponent = styled.p<{ fontSize?: string, marginTop?:string,marginBottom?:string, lineHeight?:string,light?:boolean,marginRight?:string }>`
  margin-top: ${(props) => props.marginTop || "15px"};
  margin-bottom: ${(props) => props.marginBottom || "auto"};
  margin-right: ${(props) => props.marginRight || "unset"};
  color: ${({ theme: { darkMode } }) =>darkMode ? Colors.GRAY4 : Colors.GRAY2};
  font-size: ${(props) => props.fontSize || "22px"};
  font-weight: ${(props) => props.light? "400" : "600"};;
  line-height: ${(props) => props.lineHeight || "1.5"};
`;

export default TitleComponent;
